import { applyOperations, Diff, Entity } from "../";
import { KvStore } from "./Database";
import { Finder } from "../"

class ObjectRepository<T extends Entity<T>> implements Finder<T> {
    private _diffIndex: KvStore<T>;
    private _identityFunc: () => T;
    private _values : Record<string, T>={};
    private _valuesFunc : Record<string, ()=>T> = {};
    private _corrupted : string[] = [];

    constructor(diffIndex:KvStore<T>, identityFunc:() => T) {
        this._diffIndex = diffIndex;
        this._identityFunc = identityFunc;
    }

    async init () {
        let allObjects = await this._diffIndex.getAll();
        allObjects.forEach(crDiff => {
            const valueFunc = () => {
                const diffs = crDiff.diffs;
                const value = applyOperations(diffs, undefined, this._identityFunc);
                return value;
            };
            this._valuesFunc[crDiff.uuid] = valueFunc;
        });
    }

    async append(uuid: string, diff:Diff<T>) : Promise<T> {
        await this._diffIndex.append(uuid, diff);
        const value = applyOperations([diff], this._values[uuid], this._identityFunc);
        
        this._values[uuid] = value;
        return this._values[uuid];
    }

    getAll() : T[] {
        const materializedKeys = Object.keys(this._values);
        const unmaterializedKeys = Object.keys(this._valuesFunc);
        if (materializedKeys.length < unmaterializedKeys.length) {
            unmaterializedKeys
                .filter(key => materializedKeys.findIndex(k => k === key) == -1)
                .forEach(key => {
                    try {
                      this._values[key] = this._valuesFunc[key]();
                    } catch (e) {
                        this._diffIndex.get(key)
                            .then(diffs => {
                                console.error("Invalid data : ", diffs);
                            });
                        this._corrupted.push(key)
                    }
                });
        }
        const identity = this._identityFunc();
        return Object.values(this._values).filter(v => identity !== v);
    }

    findById(uuid: string ) : T | undefined {
        if (!(uuid in this._values)) {
            if (!(uuid in this._valuesFunc)) {
                return undefined;
            }
            this._values[uuid] = this._valuesFunc[uuid]();
        }
        return this._values[uuid];
    }
}

export {ObjectRepository}